import type { FeedComponentDto } from "@strtmn/sds/types"
import { useContext } from "react"
import { FaMountain } from "react-icons/fa6"
import { useParams } from "react-router-dom"
import config from "../../../config"
import { UserDataContext, UserDataContextHelper } from "../../../contexts"
import FeedComponentItem from "../-components/FeedComponentItem"
import { ListPage } from "../-components/ListPage"

import "../RecipeManagement.css"

export default function FeedComponents() {
  const params = useParams()
  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.findOrg(params["orgId"]!, userData!)
  const feedComponents = UserDataContextHelper.findFeedComponents(org)

  return (
    <>
      <ListPage
        _className="feed-components"
        icon={<FaMountain className="w-5 _h-3.5_ relativ text-[#3E9E29]" />}
        title="Komponenten"
        items={feedComponents.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: "base",
            numeric: true,
          })
        )}
        maxNumItems={config.limits.numberOfFeedComponents}
        renderFunc={(item: FeedComponentDto) => (
          <FeedComponentItem
            key={item.id}
            org={org}
            item={item}
            hasEditButton
          />
        )}
      />

      {/* <small>
      * Die Icons "mountains" (Plural), "sliders-up", "eye (light)" benötigen FontAwesome Pro, kostet 49,- oder 99,- pro Jahr.<br />
      * Die Schrift der Namen ist hier kleiner (als bei Ausladestellen und Rezepten), verm. weil das Bild kleiner ist.
    </small> */}
    </>
  )
}
